import PropTypes from 'prop-types';
// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';

// project imports
import { useAuth } from 'contexts/AuthContext';

// assets
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab({ handleLogout }) {
  const { user, logout } = useAuth();

  const handleLogoutClick = () => {
    logout();
    if (handleLogout) handleLogout();
  };

  return (
    <Box>
      {/* Información del usuario */}
      <Box sx={{ p: 2 }}>
        <Typography variant="subtitle2" color="text.secondary">
          Información del Usuario
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          <strong>Email:</strong> {user?.email}
        </Typography>
        <Typography variant="body2">
          <strong>Rol:</strong> {user?.role}
        </Typography>
        <Typography variant="body2">
          <strong>Fecha de creación:</strong> {user?.createdAt}
        </Typography>
      </Box>
      
      <Divider />
      
      <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
        <ListItemButton>
          <ListItemIcon>
            <UserOutlined />
          </ListItemIcon>
          <ListItemText primary="Ver Perfil" />
        </ListItemButton>
        
        <ListItemButton onClick={handleLogoutClick}>
          <ListItemIcon>
            <LogoutOutlined />
          </ListItemIcon>
          <ListItemText primary="Cerrar Sesión" />
        </ListItemButton>
      </List>
    </Box>
  );
}

ProfileTab.propTypes = { handleLogout: PropTypes.func };
